import React, { FunctionComponent } from 'react'
import { QuickKeyNodeType } from '../utils/qk.constants'
import { QuickKeyBlank, QuickKeyFolder, QuickKeyKey } from '../utils/qk-types'
import { HandleDropParams } from '../quickKeyUtils'
import { QKKey } from './QKKey'
import { QKFolder } from './QKFolder'
import { QKBlank } from './QKBlank'
import { QKLocked } from './QKLocked'

interface NodeProps {
  quickKey: QuickKeyFolder | QuickKeyKey | QuickKeyBlank | null
  isFocussed?: boolean
  isSelected?: boolean
  setFocus: (qk: QuickKeyFolder | QuickKeyKey | QuickKeyBlank) => void
  selectQuickKey: (qk: QuickKeyFolder | QuickKeyKey | QuickKeyBlank) => void
  editFolder?: (folder: QuickKeyFolder) => void
  handleDrop?: (params: HandleDropParams) => void
}

export const QKNode: FunctionComponent<NodeProps> = ({
  quickKey,
  isFocussed,
  isSelected,
  setFocus,
  selectQuickKey,
  editFolder,
  handleDrop,
}) => {
  if (!quickKey) {
    return null
  }

  if (quickKey.locked) {
    return <QKLocked />
  }

  switch (quickKey.type) {
    case QuickKeyNodeType.FOLDER:
      return (
        <QKFolder
          quickKey={quickKey}
          isFocussed={isFocussed}
          onClick={selectQuickKey}
          setFocus={setFocus}
          handleDrop={handleDrop}
        />
      )
    case QuickKeyNodeType.QUICK_KEY:
      return (
        <QKKey
          quickKey={quickKey}
          isFocussed={isFocussed}
          setFocus={setFocus}
          onClick={selectQuickKey}
          handleDrop={handleDrop}
        />
      )
    case QuickKeyNodeType.BLANK:
      return (
        <QKBlank
          quickKey={quickKey}
          isFocussed={isFocussed}
          isSelected={isSelected}
          setFocus={setFocus}
          onClick={selectQuickKey}
          handleDrop={handleDrop}
        />
      )
    default:
      return null
  }
}
